export default "__VITE_PUBLIC_ASSET__31f15657__"